import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
const CtaGroup = ({ ctaText, link }) => {
  return (
    <Link to={link ? link : "#"} className="cta-group">
      {" "}
      <span>{ctaText}</span>{" "}
      <i>
        <Icon icon="ep:arrow-right" />
      </i>
    </Link>
  );
};

export default CtaGroup;
